/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import ParticipantDetailsPage from './participant.details.page';
import { changeTab } from 'actions/actions';
import { fetchParticipantDetails } from '../../actions/actions';

export const mapStateToProps = (state, ownProps) => {
  return {
    tab: state.participantDetails.tab,
    error: state.subject.errorUpdateJourney,
    isFetching: state.subject.isFetchingStudy || state.subject.isFetchingJourney || state.subject.phi.isFetching,
    participantJourney: state.subject.participantJourney,
    participantStudy: state.subject.participantStudy
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleSelect: (key) => {
      dispatch(changeTab(key));
    },
    fetchParticipantJourney: (participantJourneyGid) => {
      dispatch(fetchParticipantDetails(participantJourneyGid));
    }
  };
};

const ParticipantDetailsPageContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantDetailsPage);

export default ParticipantDetailsPageContainer;
